export interface IValidation {
  validationResults: IValidationResults[];
}

export interface IValidationResults {
  albumId: number;
  validationLevel: ValidationLevel;
  trackId: number | null;
  fieldName: string;
  isValid: string;
  validationMessage: string;
  errorCode: ErrorCode | null;
  errorType: ErrorType | null;
  details?: IIsrcMetadataConflictDetails | null;
}

export interface IIsrcMetadataConflictDetails {
  isrc: string;
  source: string;
  conflictingProductId?: string | null;
  conflictingTrackId?: string | null;
  conflictingCatalogUpc?: string | null;
  mismatches: IIsrcMetadataMismatch[];
}

export interface IIsrcMetadataMismatch {
  field: string;
  fieldKey?: string | null;
  artistOrdinal?: number | null;
  currentValue?: string | null;
  otherValue?: string | null;
}

export enum ValidationLevel {
  Album = 'Album',
  Track = 'Track',
  Restrictions = 'Restrictions',
}

export enum ErrorCode {
  ProductInfoMissingOrInvalid = 'ProductInfoMissingOrInvalid',
  TrackInfoMissingOrInvalid = 'TrackInfoMissingOrInvalid',
  ArtistList = 'ArtistList',
  TrackList = 'TrackList',
  WriterComposerList = 'WriterComposerList',
  PublisherList = 'PublisherList',
  InvalidCoverArt = 'InvalidCoverArt',
}

export enum ErrorType {
  NullorEmpty = 'NullorEmpty',
  InvalidValue = 'InvalidValue',
  DuplicateUsage = 'DuplicateUsage',
  FailedCheckDigitCalculation = 'FailedCheckDigitCalculation',
  EmptyList = 'EmptyList',
  SequenceError = 'SequenceError',
  IncorrectVolumeOrTrackNumber = 'IncorrectVolumeOrTrackNumber',
  IncorrectVolumeSequence = 'IncorrectVolumeSequence',
  IncorrectTrackNumberSequence = 'IncorrectTrackNumberSequence',
  NotMatchingSum = 'NotMatchingSum',
  ExceedsMaxLength = 'ExceedsMaxLength',
  MissingAllowedSalesTeamPrice = 'MissingAllowedSalesTeamPrice',
  MissingPrimarySalesTeam = 'MissingPrimarySalesTeam',
  MetadataConflict = 'MetadataConflict',
}

export interface ValidationMetadata {
  minimumReleaseDate: string;
  minimumReleaseDateVmgManufacturing: string;
}
